import { render, staticRenderFns } from "./detailProductsCompound.vue?vue&type=template&id=20edb9a7&"
import script from "./detailProductsCompound.vue?vue&type=script&lang=js&"
export * from "./detailProductsCompound.vue?vue&type=script&lang=js&"
import style0 from "./detailProductsCompound.vue?vue&type=style&index=0&id=20edb9a7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports